"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAP_STATUS_LIST = exports.MAP_PADDING = exports.MAP_CONFIG = void 0;
var MAP_CONFIG = {
  hPadding: 1300,
  originGameSpaceHeight: 1950,
  originGameSpaceWidth: 2600,
  originMapHeight: 3250,
  originMapWidth: 5200,
  vPadding: 650
}; // Игровая зона находится по центру не заходя за шапку и футер.
// Так как шапка и футер сдвинуты вверх и вних соответственно на толщину бордера, то его тоже необходимо учитывать.

exports.MAP_CONFIG = MAP_CONFIG;
var footerHeight = 62;
var headerHeight = 62;
var borderWidth = 3;
var MAP_PADDING = footerHeight + headerHeight - 2 * borderWidth;
exports.MAP_PADDING = MAP_PADDING;
var MAP_STATUS_LIST = {
  CURRENT: 'CURRENT',
  NOT_PLAYED: 'NOT_PLAYED',
  PLAYED: 'PLAYED'
};
exports.MAP_STATUS_LIST = MAP_STATUS_LIST;
MAP_CONFIG.goalGameProportional = MAP_CONFIG.originGameSpaceWidth / MAP_CONFIG.originGameSpaceHeight;
MAP_CONFIG.goalMapProportional = MAP_CONFIG.originMapWidth / MAP_CONFIG.originMapHeight;